<template>
  <div class="wl-results" v-if="doc">
    <results-bar :doc="doc" @loadSummary="loadSummary" @loadUser="loadUser" :includeAdmin="true"></results-bar>
    <results-summary v-if="summary" :id="doc.id"></results-summary>
    <results-user v-if="!summary" :uid="currentUser" :id="doc.id"></results-user>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { store } from '@/store.js'
import {
  ResultsUser,
  ResultsBar,
  ResultsSummary
} from "@/components/results/problem";
const fb = require("@/firebaseConfig.js");
export default {
  name: "ResultTraffic",
  props: {
    doc: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      summary: true,
      summaryMode: "popular",
      currentUser: null,
      userList: null
    };
  },
  components: {
    ResultsUser,
    ResultsBar,
    ResultsSummary
  },
  mounted() {
    this.getExercise();
  },
  computed: {
    ...mapState(["exProblem"])
  },
  methods: {
    loadSummary(mode) {
      this.currentUser = null;
      this.summaryMode = mode;
      this.summary = true;
    },
    loadUser(uid) {
      this.currentUser = uid;
      this.summary = false;
    },
    getExercise() {
      let ref = fb.problemExCollection.where("pid", "==", this.doc.id);
      ref
        .get()
        .then((result) => {
          let items = [];
          let users = [];
          result.docs.forEach((doc) => {
            let post = doc.data();
            users.push(post.uid);
            
            post.doc.forEach((item) => {
              items.push(item);
            });
          });
          if (items) {
            // this.exList = items;
             store.commit('setExProblem', items)
          }
          if (users) {
            this.userList = users;
          }
        })
        .catch(function() {});
    },
  },
};
</script>
